/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  CustomerTitleService,
  type Wealthlane_CustomerService_Dtos_CustomerTitle_CustomerTitleDto,
  type Wealthlane_CustomerService_Dtos_CustomerTitle_UpdateCustomerTitleDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

const usePostJobTitle = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  id?: string
): UseMutationResult<
  | Wealthlane_CustomerService_Dtos_CustomerTitle_CustomerTitleDto
  | Wealthlane_CustomerService_Dtos_CustomerTitle_UpdateCustomerTitleDto
  | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      if (id != null && id !== '') {
        return await handleRequest(
          CustomerTitleService.putApiCustomerApiAppCustomerTitleCustomerTitle({
            ...payload,
            id,
          })
        );
      }
      return await handleRequest(
        CustomerTitleService.postApiCustomerApiAppCustomerTitleCustomerTitle(payload)
      );
    },
    {
      onSuccess: async (
        response:
          | Wealthlane_CustomerService_Dtos_CustomerTitle_CustomerTitleDto
          | Wealthlane_CustomerService_Dtos_CustomerTitle_UpdateCustomerTitleDto
          | undefined
      ) => {
        if (response != null) {
          await queryClient.invalidateQueries('getCustomerTitleListWithPagination');
          closeModal();
          toast.success(
            <ToastComponent
              label='Success'
              message={`Job Title ${id != null && id !== '' ? 'edited.' : 'added.'}`}
            />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostJobTitle;
